import * as React from "react"
import type { IconProps } from "../types"

const ArrowDownCircle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={color}
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM16.7071 12.7071L15.2929 11.2929L13 13.5858V7H11V13.5858L8.70711 11.2929L7.29289 12.7071L12 17.4142L16.7071 12.7071Z"
        />
      </svg>
    )
  }
)
ArrowDownCircle.displayName = "ArrowDownCircle"

export default ArrowDownCircle
